import { dashboardApi } from './http';
import { extractFilters } from '../utils/filters';
import { getAuthInLocalStorage } from '../utils/localStorage';

// eslint-disable-next-line import/prefer-default-export
export async function getFilters(groupId) {
  const { token } = getAuthInLocalStorage();
  dashboardApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  const response = await dashboardApi.get(`/dashboard/v1/filter/full/${groupId}`);
  return extractFilters(response.data);
}

export async function saveFilters(data) {
  const { token } = getAuthInLocalStorage();
  dashboardApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  const response = await dashboardApi.put('/dashboard/v1/filterData', data);
  return response;
}
